import RaiseFundsNew from './RaiseFundsNew'

export default RaiseFundsNew
